import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import Seo from "@/lib/Seo";

export default function ThankYou() {
  return (
    <>
      <Seo path="/thank-you" title="شكرًا لك" description="تم استلام طلب تشخيص منظمتك." />
      <section className="min-h-[70svh] bg-navy text-white flex items-center pt-24" style={{ backgroundColor: "var(--navy)" }} data-testid="thank-you-page">
        <div className="mx-auto max-w-[800px] px-6 sm:px-10 text-center">
          <CheckCircle2 size={56} style={{ color: "var(--peach)" }} className="mx-auto" />
          <h1 className="mt-6 font-display leading-tight" style={{ fontSize: "clamp(1.7rem, 3.3vw, 2.7rem)" }}>وصلنا طلبك، شكرًا لك</h1>
          <p className="mt-5 text-white/75 text-lg leading-relaxed">
            استلم فريق سياق طلب تشخيص منظمتك، وسنعود إليك في أقرب وقت لبدء الخطوة الأولى نحو حلٍّ مصمّم على سياقك.
          </p>
          <Link to="/" className="mt-9 inline-flex items-center gap-2 bg-coral text-white px-7 py-4 font-semibold" style={{ backgroundColor: "var(--coral)" }} data-testid="thankyou-home">
            العودة إلى الرئيسية <ArrowLeft size={18} />
          </Link>
        </div>
      </section>
    </>
  );
}
